import Tone from 'tone';
import PaletteChooser from './track/PaletteChooser.js';
import {PALETTE_EFFECT} from 'effects/live/constants.js';
import Colors from "components/Colors.js"
import React, { Component } from 'react';
import Notes from 'Notes';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import ConditionedComponent from 'components/ConditionedComponent.js';
import MidiEffectComponent from 'components/effects/MidiEffectComponent.js';
import EffectsComponent from 'components/effects/EffectsComponent.js';
import {AUDIO_FX, MIDI_FX, INSTRUMENT} from 'constants/show-step-options.js';
import MultiSynthComponent from 'components/instruments/MultiSynthComponent.js';
import FMSynthComponent from 'components/instruments/FMSynthComponent.js';
import MetalSynthComponent from 'components/instruments/MetalSynthComponent.js';
import {
    updateStepParameter
       } from 'operations/actions.js';
import InstrumentComponent from 'components/effects/InstrumentComponent.js';
import {setShowStepOptions} from 'actions/index.js';
import { connect } from "react-redux";
import {
    SYNTH,
    MULTI_SYNTH,
    FM_SYNTH,
    METAL_SYNTH} from 'constants/instrument-types.js';
import '../Parameters.css';
import '../Steps.scss';

const colors = new Colors();

class StepParameters extends Component {
    constructor(props) {
        super(props);

        this.state= {
            showMoreParameters: false,
            refined: false,
        };
    } 

    get effectToShow() {
        return this.props.showStepOptions === undefined ?
            undefined : 
            this.props.showStepOptions.effect; 
    }

    get showOption() {
        return this.props.showStepOptions === undefined ?
            undefined :
            this.props.showStepOptions.option;
    }

    hasMidiFX() {
        return this.props.track.midiEffects.effects.length > 0;
    }

    hasInstrument() {
        return this.props.track.instrument !== undefined;
    }

    onClickMore() {
        this.setState({
            showMoreParameters: !this.state.showMoreParameters
        });
    }

    shouldBeRefined() {
        return this.props.stepData.duration % 1 !== 0 ||
            this.props.stepData.transpose % 1 !== 0;
    }
    
    onChangeRefined(val) {
        let refined = val === 'refined';
        document.activeElement.blur()
        this.setState({
            refined: refined,
        });
    }

    onChangeDuration(val) {
        this.props.sequencerEngine.operationManager.dispatch(
            updateStepParameter(
                this.props.track,
                this.props.stepData,
                this.props.stepData.durationParameter,
                val));
        this.setState(this.state);
    }

    onChangeChop(val) {
       this.props.sequencerEngine.operationManager.dispatch(
            updateStepParameter(
                this.props.track,
                this.props.stepData,
                this.props.stepData.chopParameter,
                val));
        // this.props.onUpdateStepData(this.props.stepData);
        this.state.chop = val;
        this.setState(this.state);
    }

    onChangeParameter(parameter, val) {
       this.props.sequencerEngine.operationManager.dispatch(
            updateStepParameter(
                this.props.track,
                this.props.stepData,
                parameter,
                val));
        // this.props.onUpdateStepData(this.props.stepData);
    }

    onChangeChopDuration(val) {
        this.props.stepData.chopDuration = val;
        // this.props.onUpdateStepData(this.props.stepData);
        this.state.chopDuration = val;
        this.setState(this.state);
    }

    onChangeTranspose(val) {
       this.props.sequencerEngine.operationManager.dispatch(
            updateStepParameter(
                this.props.track,
                this.props.stepData,
                this.props.stepData.transposeParameter,
                val));
        // this.props.onUpdateStepData(this.props.stepData);
        this.state.transpose = val;
        this.setState(this.state);
    }

    onChangeReversed(reversed, stepData) {
        this.props.stepData.reverse = (!stepData.reverse);
        document.activeElement.blur()
        this.setState(this.state);
    }

    onChangeVelocity(val) {
       this.props.sequencerEngine.operationManager.dispatch(
            updateStepParameter(
                this.props.track,
                this.props.stepData,
                this.props.stepData.velocityParameter,
                val));
        // this.props.onUpdateStepData(this.props.stepData);
        this.state.velocity = val;
        this.setState(this.state);
    }

    onChangeSlice(val) {
        this.props.sequencerEngine.operationManager.dispatch(
            updateStepParameter(
                this.props.track,
                this.props.stepData,
                this.props.stepData.sliceParameter,
                val));
        this.state.slice = val;
        this.setState(this.state);
    }

    get effects() {
        return this.props.track.effectsChains[this.props.effectsChain].effects;
    }

    onClickFX() {
        if (this.effects.length > 0) {
            this.props.setShowStepOptions(AUDIO_FX, 0);
        }
    }

    onClickInstrument() {
        return this.props.setShowStepOptions(INSTRUMENT, 0);
    }

    onClickMidiFX() {
        this.props.setShowStepOptions(MIDI_FX, 0);
    }

    onClickNextFX() {
        let effects = this.showOption === MIDI_FX ? this.midiFX : this.effects;
        if (effects.length > 0) {
            let next = (this.effectToShow + 1) % effects.length;
            this.props.setShowStepOptions(
                this.showOption, next);
        }
    }

    onClickBack() {
        this.props.setShowStepOptions(
            undefined);
    }

    onChangePanning(val) {
        this.props.stepData.panning = val;
        // this.props.onUpdateStepData(this.props.stepData);
        this.state.panning = val;
        this.setState(this.state);
    }

    getParametersToShow(stepData) {
        let durationMin = this.state.refined ? 0.01 : 1;
        let durationMax  = this.state.refined ? 2 : 64;
        let note = this.props.isMidi ? Notes.middleC.transpose(stepData.transpose).toString() :
            stepData.transpose;
        let stepValue = this.state.refined ? 0.01 : 1;

        if (this.state.showMoreParameters) {
            return (
                <div>
                  <ParameterSlider
                    label="Attack" labelValue={stepData.attack}
                    value={stepData.attack}
                    min={0} step={1} max={4000}
                    onChange={(v) => this.onChangeParameter(this.props.stepData.attackParameter, v)}
                    /> 
                  <ParameterSlider
                    label="Release" labelValue={stepData.release}
                    value={stepData.release}
                    min={0} step={1} max={6000}
                    onChange={(v) => this.onChangeParameter(this.props.stepData.releaseParameter, v)}
                    /> 
                  <ParameterSlider
                    label="Pitch Attack" labelValue={stepData.pitchAttack}
                    value={stepData.pitchAttack}
                    min={0} step={1} max={6000}
                    onChange={(v) => this.onChangeParameter(this.props.stepData.pitchAttackParameter, v)}
                    /> 
                  <ParameterSlider
                    label="Pitch Decay" labelValue={stepData.pitchDecay}
                    value={stepData.pitchDecay}
                    min={0} step={1} max={6000}
                    onChange={(v) => this.onChangeParameter(this.props.stepData.pitchDecayParameter, v)}
                    /> 
                  <ParameterSlider
                    label="Pitch Sustain" labelValue={stepData.pitchSustain}
                    value={stepData.pitchSustain}
                    min={-10} step={0.01} max={10}
                    onChange={(v) => this.onChangeParameter(this.props.stepData.pitchSustainParameter, v)}
                    /> 
                  <ParameterSlider
                    label="Pitch Release" labelValue={stepData.pitchRelease}
                    value={stepData.pitchRelease}
                    min={0} step={1} max={8000}
                    onChange={(v) => this.onChangeParameter(this.props.stepData.pitchReleaseParameter, v)}
                    /> 
                </div>
            );
        }

        let panning = stepData.panning === null ? this.props.track.getPanning() :
            stepData.panning;
        return (
            <div>
              <ParameterSlider label="Duration" labelValue={stepData.duration}
                               value={stepData.duration}
                               min={durationMin} step={stepValue} max={durationMax}
                               onChange={(v) => this.onChangeDuration(v)}> </ParameterSlider>
              <ParameterSlider label="Chop" labelValue={stepData.chop}
                               value={stepData.chop}
                               min={1} step={1} max={64}
                               onChange={(v) => this.onChangeChop(v)}> </ParameterSlider>
              <ParameterSlider label="Slice" labelValue={stepData.slice + 1}
                               isSlice={true}
                               value={stepData.slice}
                               min={0} step={1} max={this.props.slices - 1}
                               onChange={(v) => this.onChangeSlice(v)}> </ParameterSlider>
              <ParameterSlider label="Transpose" labelValue={note} value={stepData.transpose}
                               min={-23} max={23} step={1}
                               onChange={(v) => this.onChangeTranspose(v)}> </ParameterSlider>
              <ParameterSlider label="Velocity" labelValue={stepData.velocity}
                               value={stepData.velocity}
                               min={0} max={1} step={0.1}
                               onChange={(v) => this.onChangeVelocity(v)}> </ParameterSlider>
              <ParameterSlider label="Pan" labelValue={panning}
                               value={panning}
                               min={-1} max={1} step={0.1}
                               onChange={(v) => this.onChangePanning(v)}> </ParameterSlider>
        </div>);
    }

    getCheckboxes(stepData) {
        return (<div>
             <div className="reverse-parameter">
                <form>
                  <div className="refined-checkbox">
                    <label>
                      <input 
                        type="checkbox"
                        value="reversed"
                        checked={stepData.reverse}
                onChange={(e) => this.onChangeReversed(e.target.value, stepData)} />
                        Reverse 
                    </label>
                  </div>
                </form>
              </div>
              <div className="refined-parameter">
                <form>
                  <div className="refined-checkbox">
                    <label>
                      <input 
                        type="checkbox"
                        value="refined"
                        checked={this.state.refined}
                        onChange={(e) => this.onChangeRefined(e.target.value)} />
                        Refine
                    </label>
                  </div>
                </form>
              </div>
                </div>
               );
    }

    getPalettes() {
        let palettes = this.props.track.liveEffects.effects.find(
            e => e.effect === PALETTE_EFFECT);

        if (palettes === undefined) {
            return [];
        }

        return (<PaletteChooser effect={palettes} stepData={this.props.stepData}/>);
    }

    get midiFX() {
        return this.props.track.midiEffects.effects;
    }

    effectExists(effectNumber) {
        if (this.showOption === MIDI_FX) {
            return this.midiFX[effectNumber] !== undefined;
        } else {
            return this.effects[effectNumber] !== undefined;
        }
    }

    render() {
        let stepData = this.props.track.getStepDataForStep(this.props.stepData, true);

        let showAutomation = 
            (this.showOption === INSTRUMENT && this.hasInstrument()) ||
            (this.showOption === MIDI_FX && this.hasMidiFX()) ||
            (this.showOption === AUDIO_FX && this.effects.length > 0);

        if (showAutomation) {
            return (
                <div>
                  {this.getEffectOrInstrument()}
                  <div className="effects-parameters-button-container">
                    <ConditionedComponent condition={this.showOption === AUDIO_FX || this.state.showOption === MIDI_FX}>
                      <div onClick={() => this.onClickNextFX()}className="small-button pink-button float-right">NEXT</div>
                    </ConditionedComponent>
                    <div onClick={()=> this.onClickBack()} className="small-button pink-button float-right">BACK</div>
                  </div>
                </div>);
        } else {
        return (
            <div> 
              {this.getParametersToShow(stepData)}
              {this.getPalettes(stepData)}
              {this.getCheckboxes(stepData)}
              <div className="effects-parameters-button-container">
                <div
                  onClick={() => this.onClickMore()}
                  className="small-button pink-button float-right">{this.state.showMoreParameters ? 'BACK' : 'MORE'}</div>
              </div>
                   
            </div>);
        }
    }

    getEffectOrInstrument(effectNumber=this.effectToShow) {
        let effect = this.showOption === MIDI_FX ?
            this.props.track.midiEffects.effects[effectNumber] :
            this.effects[effectNumber];

        if (this.showOption === MIDI_FX && this.effectExists(effectNumber)) {
            return (
                <MidiEffectComponent
                  onEffectsChange={() => this.props.track.updateEffects()}
                  sequencerEngine={this.props.sequencerEngine}
                  effect={effect}
                  track={this.props.track}
                  effectNumber={effectNumber}
                  automation={this.props.stepData.effectAutomations}
                  />);
        } else if (this.showOption === AUDIO_FX && this.effectExists(effectNumber)) {
            return (
                <EffectsComponent.EffectComponent
                    onEffectsChange={() => this.props.track.updateEffects()}
                    sequencerEngine={this.props.sequencerEngine}
                    effect={effect}
                    track={this.props.track}
                    effectNumber={effectNumber}
                    automation={this.props.stepData.effectAutomations}
                    />
            );
        } else if (this.showOption === INSTRUMENT && this.hasInstrument()) {
            let type  = this.props.track.instrument.getInstrumentType();
            if (type === SYNTH) {
                return (
                    <InstrumentComponent
                      track={this.props.track}
                      automation={this.props.stepData.effectAutomations}
                      instrument={this.props.track.getInstrument()}
                      />
                );
            } else if (type === MULTI_SYNTH) {
                return (
                    <MultiSynthComponent
                      sequencerEngine={this.props.sequencerEngine}
                      track={this.props.track}
                      automation={this.props.stepData.effectAutomations}
                      instrument={this.props.track.getInstrument()}
                      />
                );
            } else if (type === FM_SYNTH) {
                return (
                    <FMSynthComponent
                      sequencerEngine={this.props.sequencerEngine}
                      track={this.props.track}
                      automation={this.props.stepData.effectAutomations}
                      instrument={this.props.track.getInstrument()}
                      />
                );
            } else if (type === METAL_SYNTH) {
                return (
                    <MetalSynthComponent
                      sequencerEngine={this.props.sequencerEngine}
                      automation={this.props.stepData.effectAutomations}
                      track={this.props.track}
                      instrument={this.props.track.getInstrument()}
                      />
                );
            }
        }

        return '';
    }
}


class ParameterSlider extends Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.value !== nextProps.value || this.props.step !== nextProps.step) {
            return true;
        }
        return false;
    }

    render() {
        return (
            <div className="step-parameter">
              <div className="parameter-label">{this.props.label}: {Math.round(10*this.props.labelValue)/10.0}
             </div>
              {this.props.isSlice ?
               <div
                 style={{
                     backgroundColor: colors.getColor(this.props.labelValue - 1)
                 }}
                 className="slice-indicator" /> :''}
              <ReactBootstrapSlider
                  value={this.props.value}
                  change={(e) => this.props.onChange(e.target.value)}
                  step={this.props.step}
                  max={this.props.max}
                  min={this.props.min}
                  orientation="horizontal"
                  reversed={false}
                  /> 
              </div>
        );
    }
      
}

const mapDispatchToProps = dispatch => {
    return {
        setShowStepOptions: (opt, effect) => dispatch(setShowStepOptions(opt, effect))
    };
};

const mapStateToProps = (state, props) => {
    let n = props.track.trackNumber;
    let chain = state.tracks.trackEffectsChain[n] || 0;

    return {
        effectsChain: chain,
        showStepOptions: state.steps.showStepOptions,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepParameters);
